/**
 * Add margin to footer for fixed 'add to cart' div o mobile
 */
const addToCartDiv = document.querySelector('.product-add-to-cart')
if (addToCartDiv) {
  handleFooterMargin()
  window.addEventListener('resize', handleFooterMargin)
}

function handleFooterMargin() {
  const footer = document.querySelector('.footer-container')
  if (window.matchMedia('(max-width: 768px)').matches && addToCartDiv) {
    const divHeight = addToCartDiv.offsetHeight
    footer.style.marginBottom = '100px'
  } else {
    footer.style.marginBottom = '0'
  }
}

// Brands color differences
document.addEventListener('DOMContentLoaded', function () {
  const btns = [...document.querySelectorAll('.btn')]
  const outlinesBannerAnim = [...document.querySelectorAll('.outline')]

  // -------------------------------------------------------------------------------------
  // Based on body classlist
  // -------------------------------------------------------------------------------------
  // McCormick
  if (document.body.classList.contains('cms-id-7')) {
    btns.forEach((btn) => btn.classList.add('btn-brand1'))
    outlinesBannerAnim.forEach((txt) => {
      const sloganTxts = [...txt.querySelectorAll('.slogan-txt')]
      sloganTxts.forEach((slogan, index) => {
        console.log(slogan)
        if (index % 2 === 0) slogan.classList.add('txt-outline-brand1')
        else slogan.classList.add('txt-brand1')
      })
    })
  }
  // Landini
  else if (document.body.classList.contains('cms-id-8')) {
    btns.forEach((btn) => btn.classList.add('btn-brand2'))
    outlinesBannerAnim.forEach((txt) => {
      const sloganTxts = [...txt.querySelectorAll('.slogan-txt')]
      sloganTxts.forEach((slogan, index) => {
        console.log(slogan)
        if (index % 2 === 0) slogan.classList.add('txt-outline-brand2')
        else slogan.classList.add('txt-brand2')
      })
    })
  }
  // Homepage global
  else {
    // else if (document.body.classList.contains('page-index')) {
    outlinesBannerAnim.forEach((txt) => {
      const sloganTxts = [...txt.querySelectorAll('.slogan-txt')]
      sloganTxts.forEach((slogan, index) => {
        console.log(slogan)
        if (index % 2 === 0) slogan.classList.add('txt-outline-brand0')
        else slogan.classList.add('txt-brand0')
      })
    })
  }

  // -------------------------------------------------------------------------------------
  // Based on URL
  // -------------------------------------------------------------------------------------
  const url = new URL(window.location.href)
  const segments = url.pathname.split('/')
  const catNameInUrl = '/' + segments[1] + '/'

  // Product Page
  if (document.body.classList.contains('page-product')) {
    if (catNameInUrl.includes('mccormick')) {
      btns.forEach((btn) => btn.classList.add('btn-brand1'))
      document.querySelector('.productsslider2').style.display = 'none'
    } else if (catNameInUrl.includes('landini')) {
      btns.forEach((btn) => btn.classList.add('btn-brand2'))
      document.querySelector('.productsslider').style.display = 'none'
    }
  }
})
